export default __webpack_public_path__ + "static/media/IMG_0072.c9eede13.jpg";